export default __webpack_public_path__ + "static/landing_kr_dark-532508170093b992b15f4d5810705c67.png";